import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import IntroSect from "../compCards/IntroSect";
const PortfolioIntro = () => {
  return (
    <div
      className="intro"
      style={{
        
      }}>
      <Container fluid
        style={{
          textAlign: "center",
          backgroundSize: "cover",
          backgroundPosition: "center",
          // borderRadius: "20px",
          padding: "60px 20px",
          height:"100%",
        }}
      >
          <div className="intro-overlay"></div>
        <Row style={{zIndex:"2"}}>
          <IntroSect
            head1="Portfolio"
            head2="Portfolio"
          />
        </Row>
</Container>
    </div>
  );
};
export default PortfolioIntro;
